import { render, staticRenderFns } from "./SystemLogList.vue?vue&type=template&id=246be2d7&"
import script from "./SystemLogList.vue?vue&type=script&lang=ts&"
export * from "./SystemLogList.vue?vue&type=script&lang=ts&"
import style0 from "./SystemLogList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports